import {ReactNode} from "react";

import './PageHeader.css';

/**
 * Props for this component
 */
interface PageHeaderProps {
  title: string
  children?: ReactNode
}

/**
 * This component works as a common header panel for pages in AMS. To use this component please pass the following props:
 *
 * @param title The title of the page
 * @param children <i>Optional</i> This will be the body of the header in case we need to show more than just the tittle.
 * Simple add a body to this tag.
 */
export default function PageHeader({title, children}: PageHeaderProps) {
  return <div id={"pageHeader"} className={"pageHeader"}>
    <h1 id={"pageHeaderTitle"} className={"title"}>{title}</h1>
    {children ? <div id={"pageHeaderBody"} className={"body"}>{children}</div> : <></>}
  </div>;
}